var _rect, _linearGradient, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63, _rect64, _rect65, _rect66, _rect67, _rect68, _rect69, _rect70, _rect71, _rect72, _rect73, _rect74, _rect75, _rect76, _rect77, _rect78, _rect79, _rect80, _rect81, _rect82, _rect83, _rect84, _rect85, _rect86, _rect87, _rect88, _rect89, _rect90, _rect91, _rect92, _rect93, _rect94, _rect95, _rect96, _rect97, _rect98, _rect99, _rect100, _rect101, _rect102, _rect103, _rect104, _rect105, _rect106, _rect107, _rect108, _rect109, _rect110, _rect111, _rect112, _rect113, _rect114, _rect115, _rect116, _rect117, _rect118, _rect119, _rect120, _rect121, _rect122, _rect123, _rect124, _rect125, _rect126, _rect127, _rect128, _rect129, _rect130, _rect131, _rect132, _rect133, _rect134, _rect135, _rect136, _rect137, _rect138, _rect139, _rect140, _rect141, _rect142, _rect143, _rect144, _rect145, _rect146, _rect147, _rect148, _rect149, _rect150, _rect151, _rect152, _rect153, _rect154, _rect155, _rect156, _rect157, _rect158, _rect159, _rect160, _rect161, _rect162, _rect163, _rect164, _rect165, _rect166, _rect167, _rect168, _rect169, _rect170, _rect171, _rect172, _rect173, _rect174, _rect175, _rect176, _rect177, _rect178, _rect179, _rect180, _rect181, _rect182, _rect183, _rect184, _rect185, _rect186, _rect187, _rect188, _rect189, _rect190, _rect191, _rect192, _rect193, _rect194, _rect195, _rect196, _rect197, _rect198, _rect199, _rect200, _rect201, _rect202, _rect203, _rect204, _rect205, _rect206, _rect207, _rect208, _rect209, _rect210, _rect211, _rect212, _rect213, _rect214, _rect215, _rect216, _rect217, _rect218, _rect219, _rect220, _rect221, _rect222, _rect223, _rect224, _rect225, _rect226, _rect227, _rect228, _rect229, _rect230, _path, _path2, _path3, _rect231, _rect232, _rect233, _rect234;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "464px",
    height: "464px",
    viewBox: "0 0 464 464",
    enableBackground: "new 0 0 464 464",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 464,
    height: 464,
    fill: "rgb(255,255,255)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(32,32)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    gradientTransform: "rotate(90)",
    id: "grad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "5%",
    stopColor: "rgb(21,89,142)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "95%",
    stopColor: "rgb(0,0,0)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "gmask"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(144,0) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(208,0) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(128,16) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(144,16) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(176,16) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(192,16) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(208,16) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(224,16) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(240,16) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(256,16) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(144,32) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(160,32) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(176,32) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(224,32) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(256,32) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(128,48) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(144,48) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(176,48) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(208,48) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(224,48) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(160,64) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(192,64) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(224,64) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(256,64) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(128,80) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(160,80) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(240,80) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(256,80) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(128,96) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(160,96) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(192,96) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(224,96) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(256,96) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(192,112) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(224,112) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(240,112) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,128) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16,128) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(32,128) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(48,128) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(64,128) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(96,128) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(112,128) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(128,128) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(144,128) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(160,128) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(192,128) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(208,128) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(224,128) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(272,128) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(304,128) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(336,128) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(368,128) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,144) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(48,144) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(80,144) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(128,144) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(144,144) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(224,144) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(256,144) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(272,144) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(304,144) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(368,144) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16,160) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(96,160) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(128,160) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(144,160) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(176,160) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(192,160) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(208,160) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(240,160) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(288,160) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(304,160) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(336,160) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(368,160) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(384,160) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect77 || (_rect77 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(48,176) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect78 || (_rect78 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(64,176) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect79 || (_rect79 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(112,176) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect80 || (_rect80 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(128,176) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect81 || (_rect81 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(144,176) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect82 || (_rect82 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(160,176) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect83 || (_rect83 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(176,176) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect84 || (_rect84 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(256,176) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect85 || (_rect85 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(384,176) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect86 || (_rect86 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,192) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect87 || (_rect87 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(80,192) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect88 || (_rect88 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(96,192) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect89 || (_rect89 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(112,192) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect90 || (_rect90 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(144,192) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect91 || (_rect91 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(176,192) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect92 || (_rect92 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(208,192) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect93 || (_rect93 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(224,192) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect94 || (_rect94 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(272,192) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect95 || (_rect95 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(288,192) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect96 || (_rect96 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(304,192) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect97 || (_rect97 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(320,192) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect98 || (_rect98 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(352,192) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect99 || (_rect99 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(368,192) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect100 || (_rect100 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(384,192) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect101 || (_rect101 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,208) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect102 || (_rect102 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(32,208) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect103 || (_rect103 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(48,208) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect104 || (_rect104 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(64,208) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect105 || (_rect105 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(144,208) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect106 || (_rect106 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(160,208) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect107 || (_rect107 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(192,208) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect108 || (_rect108 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(208,208) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect109 || (_rect109 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(272,208) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect110 || (_rect110 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(304,208) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect111 || (_rect111 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(336,208) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect112 || (_rect112 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(368,208) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect113 || (_rect113 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,224) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect114 || (_rect114 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(48,224) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect115 || (_rect115 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(96,224) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect116 || (_rect116 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(128,224) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect117 || (_rect117 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(160,224) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect118 || (_rect118 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(224,224) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect119 || (_rect119 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(240,224) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect120 || (_rect120 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(288,224) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect121 || (_rect121 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(304,224) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect122 || (_rect122 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(320,224) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect123 || (_rect123 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(336,224) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect124 || (_rect124 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(368,224) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect125 || (_rect125 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(384,224) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect126 || (_rect126 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,240) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect127 || (_rect127 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(32,240) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect128 || (_rect128 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(48,240) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect129 || (_rect129 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(128,240) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect130 || (_rect130 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(160,240) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect131 || (_rect131 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(192,240) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect132 || (_rect132 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(224,240) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect133 || (_rect133 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(240,240) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect134 || (_rect134 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(256,240) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect135 || (_rect135 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(272,240) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect136 || (_rect136 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(304,240) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect137 || (_rect137 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(320,240) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect138 || (_rect138 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(384,240) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect139 || (_rect139 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,256) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect140 || (_rect140 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(32,256) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect141 || (_rect141 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(80,256) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect142 || (_rect142 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(96,256) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect143 || (_rect143 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(128,256) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect144 || (_rect144 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(144,256) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect145 || (_rect145 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(192,256) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect146 || (_rect146 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(208,256) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect147 || (_rect147 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(224,256) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect148 || (_rect148 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(240,256) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect149 || (_rect149 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(256,256) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect150 || (_rect150 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(272,256) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect151 || (_rect151 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(288,256) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect152 || (_rect152 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(304,256) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect153 || (_rect153 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(320,256) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect154 || (_rect154 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(352,256) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect155 || (_rect155 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(128,272) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect156 || (_rect156 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(208,272) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect157 || (_rect157 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(240,272) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect158 || (_rect158 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(256,272) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect159 || (_rect159 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(320,272) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect160 || (_rect160 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(336,272) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect161 || (_rect161 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(128,288) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect162 || (_rect162 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(160,288) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect163 || (_rect163 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(176,288) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect164 || (_rect164 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(192,288) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect165 || (_rect165 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(208,288) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect166 || (_rect166 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(224,288) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect167 || (_rect167 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(256,288) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect168 || (_rect168 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(288,288) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect169 || (_rect169 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(320,288) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect170 || (_rect170 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(352,288) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect171 || (_rect171 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(368,288) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect172 || (_rect172 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(384,288) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect173 || (_rect173 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(160,304) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect174 || (_rect174 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(176,304) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect175 || (_rect175 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(256,304) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect176 || (_rect176 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(320,304) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect177 || (_rect177 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(336,304) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect178 || (_rect178 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(384,304) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect179 || (_rect179 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(128,320) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect180 || (_rect180 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(176,320) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect181 || (_rect181 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(192,320) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect182 || (_rect182 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(208,320) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect183 || (_rect183 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(224,320) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect184 || (_rect184 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(240,320) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect185 || (_rect185 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(256,320) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect186 || (_rect186 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(272,320) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect187 || (_rect187 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(288,320) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect188 || (_rect188 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(304,320) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect189 || (_rect189 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(320,320) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect190 || (_rect190 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(352,320) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect191 || (_rect191 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(128,336) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect192 || (_rect192 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(192,336) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect193 || (_rect193 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(208,336) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect194 || (_rect194 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(272,336) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect195 || (_rect195 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(288,336) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect196 || (_rect196 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(320,336) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect197 || (_rect197 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(336,336) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect198 || (_rect198 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(352,336) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect199 || (_rect199 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(368,336) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect200 || (_rect200 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(384,336) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect201 || (_rect201 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(128,352) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect202 || (_rect202 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(208,352) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect203 || (_rect203 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(272,352) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect204 || (_rect204 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(336,352) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect205 || (_rect205 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(352,352) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect206 || (_rect206 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(384,352) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect207 || (_rect207 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(128,368) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect208 || (_rect208 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(144,368) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect209 || (_rect209 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(192,368) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect210 || (_rect210 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(224,368) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect211 || (_rect211 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(256,368) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect212 || (_rect212 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(272,368) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect213 || (_rect213 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(288,368) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect214 || (_rect214 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(304,368) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect215 || (_rect215 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(320,368) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect216 || (_rect216 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(336,368) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect217 || (_rect217 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(384,368) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect218 || (_rect218 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(128,384) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect219 || (_rect219 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(144,384) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect220 || (_rect220 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(176,384) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect221 || (_rect221 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(208,384) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect222 || (_rect222 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(224,384) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect223 || (_rect223 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(288,384) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect224 || (_rect224 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(304,384) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect225 || (_rect225 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(320,384) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect226 || (_rect226 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(336,384) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect227 || (_rect227 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(352,384) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect228 || (_rect228 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(368,384) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect229 || (_rect229 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(384,384) scale(0.16,0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect230 || (_rect230 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,0) scale(1.12, 1.12)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 15,
    style: {
      fill: "none"
    },
    width: 70,
    height: 70
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M85,0H15H0v15v70v15h15h70h15V85V15V0H85z M85,85H15V15h70V85z"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(288,0) scale(1.12, 1.12)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 15,
    style: {
      fill: "none"
    },
    width: 70,
    height: 70
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M85,0H15H0v15v70v15h15h70h15V85V15V0H85z M85,85H15V15h70V85z"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,288) scale(1.12, 1.12)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 15,
    style: {
      fill: "none"
    },
    width: 70,
    height: 70
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M85,0H15H0v15v70v15h15h70h15V85V15V0H85z M85,85H15V15h70V85z"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(32,32) scale(0.48, 0.48)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect231 || (_rect231 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(320,32) scale(0.48, 0.48)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect232 || (_rect232 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(32,320) scale(0.48, 0.48)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, _rect233 || (_rect233 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))))))), _rect234 || (_rect234 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 400,
    height: 400,
    fill: "url(#grad)",
    mask: "url(#gmask)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.117d942bd978d28ba9a98c6f80dd91d9.svg";
export { ForwardRef as ReactComponent };